import type { Outlet } from "../types/cafe";

export function isOutletOpen(outlet: Outlet, now: Date = new Date()): boolean {
  const hour = now.getHours() + now.getMinutes() / 60;
  return hour >= outlet.openHour && hour < outlet.closeHour;
}
